module.exports = __webpack_public_path__ + "img/jQuery AJAX.b128d71f.png";